module.exports = __webpack_public_path__ + "static/Kubernetes-cca4d1f74f7085fc731af20a4ff6c5a7.svg";